import { useState } from "react";
import PlusUpgradeModal from "./PlusUpgradeModal.jsx";
import { useI18n } from "../i18n.jsx";
import { usePlus } from "../plus/PlusProvider.jsx";

export default function PlusNudge({
  source = "plus-nudge",
  children = null,
  className = "",
  showWhenPlus = false,
  activeLabel = null
}) {
  const plus = usePlus();
  const { t } = useI18n();
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  if (plus.isPlus && !showWhenPlus) return null;

  const classNames = ["plus-nudge", className].filter(Boolean).join(" ");
  const shouldManage = !plus.canRenewPlus && (plus.isPlus || (showWhenPlus && plus.canManageBilling));
  const label = plus.canRenewPlus ? t("plus.renewPlus") : shouldManage ? (activeLabel || t("plus.activeLabel")) : (children || t("plus.defaultNudge"));

  return (
    <>
    <button
      className={classNames}
      type="button"
      disabled={plus.billingBusy}
      onClick={() => {
        if (shouldManage) {
          plus.openCustomerPortal({ source });
        } else {
          setUpgradeOpen(true);
        }
      }}
    >
      {plus.billingBusy ? t("plus.opening") : label}
    </button>
    <PlusUpgradeModal open={upgradeOpen} onClose={() => setUpgradeOpen(false)} source={source} />
    </>
  );
}
